module.exports = __webpack_public_path__ + "img/1507879756.6c35ece1.jpg";